export const animation_appear_first = 'animate__zoomIn'
export const animation_appear_in_game = 'animate__fadeIn'
export const word_highlight = 'animate__bounce'
